import React from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

export default function Sostenibilidad() {
  const tarjetas = [
    {
      titulo: "Orar",
      descripcion:
        "Próximamente agregaremos información sobre esta área de acción.",
    },
    {
      titulo: "Donar",
      descripcion:
        "Próximamente agregaremos información sobre esta área de acción.",
    },
    {
      titulo: "Personal",
      descripcion:
        "Próximamente agregaremos información sobre esta área de acción.",
    },
    {
      titulo: "MARKETMP",
      descripcion:
        "Próximamente agregaremos información sobre esta área de acción..",
    },
  ];

  return (
    <>
      {/* =========================================
          NAVBAR
      ========================================= */}
      <Navbar />

      {/* =========================================
          CONTENIDO PRINCIPAL
      ========================================= */}
      <main className="pagina-sostenibilidad">
        {/* HERO */}
        <section className="hero-sostenibilidad"
        >
          <div className="hero-overlay-sostenibilidad">
            <div className="container text-center">
              <h1 className="hero-title-sostenibilidad display-2 fw-bold">
                Sostenibilidad
              </h1>

              <p className="hero-subtitle-sostenibilidad">
                Colabora con nosotros y construyamos un futuro con propósito.
              </p>
            </div>
          </div>
        </section>

        {/* INTRODUCCIÓN */}
        <section className="sostenibilidad-introduccion py-5">
          <div className="container text-center">
            <h2>Nuestro compromiso</h2>

            <p>
              En esta sección compartiremos próximamente información sobre
              nuestras iniciativas, proyectos y acciones relacionadas con la
              sostenibilidad y el impacto positivo en nuestras comunidades.
            </p>
          </div>
        </section>

        {/* TARJETAS */}
        <section className="sostenibilidad-tarjetas py-5">
          <div className="container">
            <h2 className="text-center mb-5">Áreas de acción</h2>

            <div className="row g-4">
              {tarjetas.map((tarjeta, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-4">
                  <div className="sostenibilidad-card">
                    {/* ESPACIO PARA FUTURA IMAGEN */}
                    <div className="sostenibilidad-card-imagen">
                      <span>Próximamente</span>
                    </div>

                    {/* CONTENIDO */}
                    <div className="sostenibilidad-card-body">
                      <h3>{tarjeta.titulo}</h3>

                      <p>{tarjeta.descripcion}</p>

                      <button type="button" className="btn-sostenibilidad">
                        CONOCER MÁS
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* SECCIÓN FUTURA */}
        <section className="sostenibilidad-futuro py-5">
          <div className="container text-center">
            <h2>Próximamente</h2>

            <p>
              Aquí podrás encontrar información, proyectos, fotografías y
              experiencias relacionadas con nuestro compromiso con la
              sostenibilidad.
            </p>
          </div>
        </section>
      </main>
    </>
  );
}
